import { observable } from "mobx";
import SalespointStatus from "./salespointStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SalespointResponse {
  id!: string;

  @observable
  name!: string;

  @observable
  status!: SalespointStatus;

  @observable
  address?: string;

  @observable
  postalCode?: string;
}
